import { createContext, useContext } from 'react';

import { UseProgressiveModalHookTypes } from './progressive-modal.types';

export const ProgressiveModalContext = createContext<UseProgressiveModalHookTypes<string>>({
  currentKey: '',
  handleJump: () => {},
  onClose: () => {},
});

export function useProgressiveModal<T>() {
  const context = useContext(ProgressiveModalContext);
  if (!context) {
    throw new Error('useProgressiveModal must be used within a ProgressiveModalContext');
  }
  return context as UseProgressiveModalHookTypes<T>;
}
